/*
 * © 2020 Microsoft. All rights reserved.
 */

define('MenuUI/GameScreenUI',['pixi', 'absolute', 'absolute/stringmanager', 'lodash', 'MenuUI/MsftIconButton', 'util/SettingsManager', 'Solitaire/SolitaireGameMode',
    'util/TipManager', 'MenuUI/DealWarningModal', 'MenuUI/ChallengeKickoff',
    'SolitaireShared/CardLogic/IDailyAuthority', 'CardUI/KeyboardNavigator',
    'absolute/particleemitter', 'MenuUI/DetailStatsItemModel', 'Managers/KeyboardManager', 'MenuUI/ControlFocusManager',
    'Managers/TelemetryManager', 'Managers/ScaleManager', 'Managers/AdManager', 'util/ScaleParams', 'MenuUI/ChallengeHud',
    'MenuUI/ChallengeStartModal', 'MenuUI/ChallengeFooter', 'MenuUI/HowToPlayPopup', 'Solitaire/MvvmStructure/Service/SolitaireStarClubService',
    'MenuUI/DifficultySelectionModal'],

    function (PIXI, Absolute, _s, _, MsftIconButton, SettingsManager, SolitaireGameMode, TipManager,
        DealWarningModal, ChallengeKickoff, IDailyAuthority, KeyboardNavigator, ParticleEmitter,
        DetailStatsItemModel, KeyboardManager, ControlFocusManager, TelemetryManager, ScaleManager, AdManager, ScaleParams,
        ChallengeHud, ChallengeStartModal, ChallengeFooter, HowToPlayPopup, SolitaireStarClubService,
        DifficultySelectionModal) {

        var GameViewDummy = function () {
            this.initGameViewDummy();
        };

        GameViewDummy.prototype.initGameViewDummy = function () {
            this.visible = true;
            this.handleActivate = function () {
            };
        };

        var GameScreenUI = function (config, ui, game) {
            this.challengeLetterFontSize = Absolute.ScreenMetrics.getResScale() * 24;
            var defaultConfig = {
                letterStyle: {
                    font: Absolute.ScreenMetrics.getResScale() * 45 + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    align: 'left'
                },
                challengeLetterStyle: {
                    font: this.challengeLetterFontSize + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    align: 'left'
                }
            };
            this.fullScreenEnabled = Absolute.GameConfig.defaults.config.UI.fullScreenEnabled;
            this.initGameScreenUI(_.extend(defaultConfig, config), ui, game);
        };

        GameScreenUI.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

        GameScreenUI.prototype.initGameScreenUI = function (config, ui, game) {

            PIXI.DisplayObjectContainer.call(this);

            this.config = config;
            this.ui = ui;
            this.game = game;
            this.settingsManager = SettingsManager;
            this.gameName = 'Klondike';
            this.mode = 'klondike';
            this.dealsLeft = 0;
            this.isChallenge = false;
            this.buttonsHidden = false;
            this.anyKeyHandler = null;
            this.updateHandlers = {
                updateChallengeTime: null,
                updateChallengeScore: null,
                updateChallengeMoves: null,
                updateChallengeStacks: null,
                updateChallengeCardsPlayed: null,
                updateChallengeDeals: null,
                updateChallengeBoards: null
            };

            this.controlFocusManager = new ControlFocusManager();
            this.controlGroup = [];

            this.buildButtons();
            this.buildLabels();

            this.actionHandlers = this.game.menuBar.getButtonHandler();

            this.isRestart = false;

            TipManager.init(ui, game, this);
        };

        GameScreenUI.prototype.handleKeyUp = function (event) {
            var command = this.getCommandFromKeyboardEvent(event);
            if (command === 'Ctrl') {
                this.crtlDown = false;
                event.preventDefault();
                return false;
            }
        };

        GameScreenUI.prototype.setAnyKeyHandler = function (anyKeyHandler) {
            this.anyKeyHandler = anyKeyHandler;
        };

        GameScreenUI.prototype.removeAnyKeyHandler = function (anyKeyHandler) {
            this.anyKeyHandler = null;
        };

        GameScreenUI.prototype.handleCommand = function (command) {
            if (this.wildCardTip) {
                return this.wildCardTip.handleCommand(command);
            } else if (this.htp) {
                return this.htp.handleCommand(command);
            } else if (TipManager.dialogShowing) {
                return TipManager.tipDialog.handleCommand(command);
            } else if (this.warning) {
                return this.warning.handleCommand(command);
            } else if (this.challengeStartModal) {
                return this.challengeStartModal.handleCommand(command);
            } else if (this.difficultySelectionModal) {
                return this.difficultySelectionModal.handleCommand(command);
            } else if (this.game.menuBar.gameOptionsPopup) {
                return this.game.menuBar.gameOptionsPopup.handleCommand(command);
            }

            var handled = false,
                action = this.actionHandlers[command];

            if (typeof action === 'function') {
                action(true);
                handled = true;
            } else if (this.game.solitaire && this.game.solitaire.SupplyView
                && this.game.solitaire.SupplyView.IsCardDragging) {
                handled = false;
            } else {
                switch (command) {
                    case 'Undo':
                        this.game.solitaire.Undo();
                        handled = true;
                        break;
                    case 'Statistics':
                        if (this.game.solitaire && this.game.solitaire.ActiveMode) {
                            var statsDetailModel = new DetailStatsItemModel(this.game.solitaire.ActiveMode.Name);
                            this.game.navStatsDetail(statsDetailModel);
                            handled = true;
                        }
                        break;
                    case 'NewGame':
                        if (this.game.solitaire.SupplyView
                            && !this.game.solitaire.SupplyView.CardSupply.CardAnimator.IsShuffleAnimationRunning()) {
                            this.confirmNewDeal();
                        }
                        handled = true;
                        break;
                    case 'Draw':
                        this.game.solitaire.SupplyView
                            .GameInputInterpreter.DealNextFromStock(this.game.solitaire.SupplyView);
                        if (this.game.solitaire.Template.UpdateStockAppearance) {
                            this.game.solitaire.Template.UpdateStockAppearance(this.game.solitaire.SupplyView);
                        }
                        handled = true;
                        break;
                    case 'Menu':
                        this.game.menuBar.toggleMainSlideOut();
                        this.game.menuBar.parent.addChild(this.game.menuBar);
                        handled = true;
                        break;
                    case 'Back':
                        if (this.game.menuBar.menuOpen) {
                            this.game.menuBar.handleCommand(command);
                        } else {
                            if (this.isChallenge) {
                                this.game.menuBar.showExitWarning(this.game.navBack.bind(this.game));
                            } else {
                                this.game.navBack();
                            }
                        }
                        handled = true;
                        break;

                    case 'Up':
                    case 'Down':
                    case 'Left':
                    case 'Right':
                    case 'Tab':
                    case 'ShiftTab':
                    case 'Activate':
                        if (this.game.menuBar.menuOpen) {
                            this.game.menuBar.handleCommand(command);
                        } else {
                            switch (command) {
                                case 'Tab':
                                    this.controlFocusManager.focusNextControl(1);
                                    break;
                                case 'ShiftTab':
                                    this.controlFocusManager.focusNextControl(-1);
                                    break;
                                case 'Activate':
                                    if (this.controlFocusManager.getCurrentControl() === this.gameViewDummy
                                        || this.controlFocusManager.getCurrentControl() === null) {
                                        if (this.game.solitaire && this.game.solitaire.SupplyView) {
                                            this.game.solitaire.SupplyView.handleCommand(command);
                                        }
                                    } else {
                                        this.controlFocusManager.activateCurrentControl();
                                    }
                                    break;
                                default:
                                    this.controlFocusManager.unfocusCurrentControl();
                                    if (this.game.solitaire && this.game.solitaire.SupplyView) {
                                        this.game.solitaire.SupplyView.handleCommand(command);
                                    }
                                    break;
                            }
                        }

                        if (this.game.solitaire && this.game.solitaire.SupplyView) {
                            this.game.solitaire.SupplyView.Focused =
                                this.controlFocusManager.getCurrentControl() === this.gameViewDummy
                                || this.controlFocusManager.getCurrentControl() === null;
                        }

                        handled = true;
                        break;
                    default:
                }
            }

            if (handled) {
                return false;
            }
        };

        GameScreenUI.prototype.triggerNewDeal = function () {
            const gameName = this.game.solitaire.Authority.CardSupply.GameName;

            const showDifficultySelection = this.settingsManager.getSetting(this.gameName.toLowerCase(), 'showDifficulty');
            if (
                showDifficultySelection &&
                (
                    gameName === 'Klondike' ||
                    gameName === 'Spider' ||
                    gameName === 'FreeCell'
                )
            ) {
                var difficultySelectionConfig = {
                    gameName: gameName,
                    gameNameText: Absolute.StringManager('tiles.' + gameName.toLowerCase()),
                    modalDescription: Absolute.StringManager('solvable.chooseGame'),
                    modalDisclaimer: '*' + Absolute.StringManager('solvable.randomDeckUnsolvable'),
                    toggleButtonSize: 25,
                    ribbonHeight: 55,
                    buttons: this.getGameSpecificDifficultyButtons(gameName),
                    gameModes: this.getGameSpecificGameModeButtons(gameName),
                    buttonHeight: 45,
                    buttonSpacing: 10,
                    isCompleted: false,
                    borderSize: 4,
                    borderColor: 0xffffff,
                    backgroundColor: 0x0d3c77,
                    width: 600,
                    height: 850, // This gets overwritten. The height adjusts to the content.
                    offsetX: 0,
                    offsetY: 0,
                    padding: 25
                };

                this.difficultySelectionModal = new DifficultySelectionModal(
                    this.ui.currentScreen,
                    this.game,
                    difficultySelectionConfig,
                    null,
                    false
                );
            } else {
                TelemetryManager.closedNewDealMenu(true);
                this.game.solitaire.DealNewGame();
            }
        };

        GameScreenUI.prototype.getGameSpecificDifficultyButtons = function (gameName) {
            if (gameName.toLowerCase() === 'klondike') {
                return [
                    { name: Absolute.StringManager('buttons.easy'), value: 'EASY' },
                    { name: Absolute.StringManager('buttons.medium'), value: 'MEDIUM' },
                    { name: Absolute.StringManager('buttons.hard'), value: 'HARD' },
                    { name: Absolute.StringManager('buttons.expert'), value: 'EXPERT' },
                    { name: Absolute.StringManager('buttons.master'), value: 'MASTER' },
                    { name: Absolute.StringManager('buttons.grandmaster'), value: 'GRANDMASTER' },
                    { name: Absolute.StringManager('buttons.random'), value: 'RANDOM' }
                ];
            }
            else if (gameName.toLowerCase() === 'spider') {
                return [
                    { name: Absolute.StringManager('buttons.easy'), value: 'EASY' },
                    { name: Absolute.StringManager('buttons.medium'), value: 'MEDIUM' },
                    { name: Absolute.StringManager('buttons.hard'), value: 'HARD' },
                    { name: Absolute.StringManager('buttons.expert'), value: 'EXPERT' },
                    { name: Absolute.StringManager('buttons.master'), value: 'MASTER' },
                    { name: Absolute.StringManager('buttons.grandmaster'), value: 'GRANDMASTER' },
                    { name: Absolute.StringManager('buttons.random'), value: 'RANDOM' }
                ];
            }
            else if (gameName.toLowerCase() === 'freecell') {
                return [
                    { name: Absolute.StringManager('buttons.easy'), value: 'EASY' },
                    { name: Absolute.StringManager('buttons.medium'), value: 'MEDIUM' },
                    { name: Absolute.StringManager('buttons.hard'), value: 'HARD' },
                    { name: Absolute.StringManager('buttons.expert'), value: 'EXPERT' },
                    // { name: Absolute.StringManager('buttons.master'), value: 'MASTER' },
                    // { name: Absolute.StringManager('buttons.grandmaster'), value: 'GRANDMASTER' },
                    { name: Absolute.StringManager('buttons.random'), value: 'RANDOM' }
                ];
            }
            else if (gameName.toLowerCase() === 'pyramid') {
                // Currently doesn't exist
                return [
                    // { name: Absolute.StringManager('buttons.easy'), value: 'EASY' },
                    // { name: Absolute.StringManager('buttons.medium'), value: 'MEDIUM' },
                    // { name: Absolute.StringManager('buttons.hard'), value: 'HARD' },
                    // { name: Absolute.StringManager('buttons.expert'), value: 'EXPERT' },
                    // { name: Absolute.StringManager('buttons.master'), value: 'MASTER' },
                    // { name: Absolute.StringManager('buttons.grandmaster'), value: 'GRANDMASTER' },
                    // { name: Absolute.StringManager('buttons.random'), value: 'RANDOM' },
                ];
            }
            else if (gameName.toLowerCase() === 'tripeaks') {
                // Currently doesn't exist
                return [
                    // { name: Absolute.StringManager('buttons.easy'), value: 'EASY' },
                    // { name: Absolute.StringManager('buttons.medium'), value: 'MEDIUM' },
                    // { name: Absolute.StringManager('buttons.hard'), value: 'HARD' },
                    // { name: Absolute.StringManager('buttons.expert'), value: 'EXPERT' },
                    // { name: Absolute.StringManager('buttons.master'), value: 'MASTER' },
                    // { name: Absolute.StringManager('buttons.grandmaster'), value: 'GRANDMASTER' },
                    // { name: Absolute.StringManager('buttons.random'), value: 'RANDOM' },
                ];
            }
            return [];
        }

        GameScreenUI.prototype.getGameSpecificGameModeButtons = function (gameName) {
            if (gameName.toLowerCase() === 'klondike') {
                return [
                    // 'Standard (Draw 1)'
                    {
                        name: Absolute.StringManager('buttons.standard') + ' (' + Absolute.StringManager('buttons.draw1') + ')',
                        scoringType: 'STANDARD', cardsPerDraw: '1', disables: [
                            // 'EASY',
                        ]
                    },
                    // 'Standard (Draw 3)'
                    {
                        name: Absolute.StringManager('buttons.standard') + ' (' + Absolute.StringManager('buttons.draw3') + ')',
                        scoringType: 'STANDARD', cardsPerDraw: '3', disables: [
                            'EASY'
                        ]
                    },
                    {
                        name: Absolute.StringManager('buttons.lasVegas') + ' (' + Absolute.StringManager('buttons.draw1') + ')',
                        scoringType: 'LASVEGAS', cardsPerDraw: '1', disables: [
                            'EASY'
                        ]
                    },
                    {
                        name: Absolute.StringManager('buttons.lasVegas') + ' (' + Absolute.StringManager('buttons.draw3') + ')',
                        scoringType: 'LASVEGAS', cardsPerDraw: '3', disables: [
                            'EASY'
                        ]
                    },
                    {
                        name: Absolute.StringManager('buttons.cumulativeVegas') + ' (' + Absolute.StringManager('buttons.draw1') + ')',
                        scoringType: 'LASVEGASCUMULATIVE', cardsPerDraw: '1', disables: [
                            'EASY'
                        ]
                    },
                    {
                        name: Absolute.StringManager('buttons.cumulativeVegas') + ' (' + Absolute.StringManager('buttons.draw3') + ')',
                        scoringType: 'LASVEGASCUMULATIVE', cardsPerDraw: '3', disables: [
                            'EASY'
                        ]
                    }
                ];
            }
            else if (gameName.toLowerCase() === 'spider') {
                return [
                    {
                        name: Absolute.StringManager('buttons.suits1'), suits: '1', disables: [
                            'GRANDMASTER'
                        ]
                    },
                    {
                        name: Absolute.StringManager('buttons.suits2'), suits: '2', disables: [
                            'EASY',
                            'MEDIUM'
                        ]
                    },
                    {
                        name: Absolute.StringManager('buttons.suits4'), suits: '4', disables: [
                            'EASY',
                            'MEDIUM',
                            'HARD'
                        ]
                    }
                ];
            }
            else if (gameName.toLowerCase() === 'freecell') {
                // Currently doesn't exist
                return [
                ];
            }
            else if (gameName.toLowerCase() === 'pyramid') {
                // Currently doesn't exist
                return [
                ];
            }
            else if (gameName.toLowerCase() === 'tripeaks') {
                // Currently doesn't exist
                return [
                ];
            }
            return [];
        }

        GameScreenUI.prototype.confirmNewDeal = function () {
            if (this.game.solitaire.Authority.CardSupply.HasMovedCards) {
                this.warning = new DealWarningModal(this.ui.currentScreen, 'dialogs.warningHeadline', 'dialogs.newDealContent',
                    function () {
                        this.game.boostType = 'no';
                        TelemetryManager.classicGameComplete(
                            'Abandoned', this.game.solitaire.Authority.CardSupply.GameName,
                            Math.floor(this.game.solitaire.Authority.CardSupply.PreciseTimePlayed),
                            this.game.solitaire.ScoringOption, this.game.solitaire.DrawOption,
                            this.game.solitaire.SuitsOption,
                            this.game.solitaire.Authority.CardSupply.Options.DIFFICULTY
                        );

                        this.triggerNewDeal();
                        this.warning.close();
                    }.bind(this),
                    function () {
                        TelemetryManager.closedNewDealMenu(false);
                        this.warning.close();
                    }.bind(this)
                );
            } else {
                this.game.boostType = 'no';
                this.triggerNewDeal();
            }
        }

        GameScreenUI.prototype.buildButtons = function () {

            // TODO: move to config?

            for (var i = 0; i < this.game.menuBar.controlGroup.length; i++) {
                this.controlGroup.push(this.game.menuBar.controlGroup[i]);
            }

            this.newDealButton = new MsftIconButton({
                'text': _s('buttons.newDeal'),
                'icon': 'Buttons/Deal/Deal.png',
                'iconDown': 'Buttons/Deal/Deal_inv.png',
                'width': Absolute.Coords.x(120), 'height': Absolute.Coords.y(64),
                'maxWidth': Absolute.ScreenMetrics.getResScale() * 100,
                'action': function () {
                    if (this.game.solitaire.SupplyView
                        && !this.game.solitaire.SupplyView.CardSupply.CardAnimator.IsShuffleAnimationRunning()) {
                            TelemetryManager.opennedNewDealMenu();
                            this.confirmNewDeal();
                    }
                }.bind(this)
            });
            this.controlGroup.push(this.newDealButton, true);

            this.settingsButton = new MsftIconButton({
                'text': _s('titles.gameOptions'),
                'icon': 'icon_settings.png',
                'iconDown': 'icon_settings.png',
                'width': Absolute.Coords.x(120), 'height': Absolute.Coords.y(64),
                'iconY': -8,
                'textY': Absolute.Coords.y(38),
                'maxWidth': Absolute.ScreenMetrics.getResScale() * 100,
                'action': function () {                    
                    this.game.menuBar.openGameOptions(false);
                    handled = true;
                }.bind(this)
            });
            this.controlGroup.push(this.settingsButton, true);

            this.hintButton = new MsftIconButton({
                'text': _s('buttons.hint'),
                'icon': 'Buttons/hint.png',
                'iconDown': 'Buttons/hint.png',
                'width': Absolute.Coords.x(120), 'height': Absolute.Coords.y(64),
                'iconY': -5,
                'textY': Absolute.Coords.y(38),
                'maxWidth': Absolute.ScreenMetrics.getResScale() * 100,
                'action': function () {
                    this.game.solitaire.Hint();
                    handled = true;
                }.bind(this)
            });
            this.controlGroup.push(this.hintButton, true);

            this.tryAgainButton = new MsftIconButton({
                'text': _s('buttons.tryAgain'),
                'icon': 'Buttons/tryagain/tryagain.png',
                'iconDown': 'Buttons/tryagain/tryagain_inv.png',
                'width': Absolute.Coords.x(120), 'height': Absolute.Coords.y(64),
                'textY': Absolute.Coords.y(38),
                'maxWidth': Absolute.ScreenMetrics.getResScale() * 100,
                'action': function () {
                    this.warning = new DealWarningModal(this.ui.currentScreen, "dialogs.warningHeadline", 'dialogs.challengeExitWarning',
                        function () {
                            var gameMode = this.game.solitaire.ActiveMode.Name,
                                challenge = this.game.solitaire.CurrentChallenge;

                            var mode = challenge.GetModeName();
                            var timeSpent = Math.floor(this.game.solitaire.Authority.CardSupply.PreciseTimePlayed);
                            var difficulty = challenge.config.Difficulty;
                            if (challenge.config.Date) {

                                var timestampStr = challenge.config.Date.substring(6, 19);
                                var date = new Date(parseInt(timestampStr));
                                var releaseDate = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
                                TelemetryManager.challengeComplete('Abandoned', mode, timeSpent, releaseDate, difficulty)
                                this.isRestart = true;
                            } else {
                                var collectionName = SolitaireStarClubService.currentCollection.Name,
                                    packName = SolitaireStarClubService.currentPack.Name;
                                TelemetryManager.starClubComplete('Abandoned', timeSpent, mode, difficulty, collectionName, packName);
                            }

                            this.game.solitaire.StopGame(false);
                            this.game.startGame(gameMode, challenge);
                            this.warning.close();
                        }.bind(this),
                        function () {
                            this.warning.close();
                        }.bind(this)
                    );

                }.bind(this)
            });
            this.controlGroup.push(this.tryAgainButton, true);

            this.undoButton = new MsftIconButton({
                'text': _s('buttons.undo'),
                'icon': 'Buttons/Undo/undo.png',
                'iconDown': 'Buttons/Undo/undo_inv.png',
                'width': Absolute.Coords.x(120), 'height': Absolute.Coords.y(64),
                'maxWidth': Absolute.ScreenMetrics.getResScale() * 115,
                'action': function () {
                    this.game.solitaire.Undo();
                }.bind(this)
            });
            this.controlGroup.push(this.undoButton, true);

            this.undoBoardButton = new MsftIconButton({
                'text': _s('buttons.undoBoard'),
                'icon': 'Buttons/Undo/undo.png',
                'iconDown': 'Buttons/Undo/undo_inv.png',
                'width': Absolute.Coords.x(120), 'height': Absolute.Coords.y(64),
                'maxWidth': Absolute.ScreenMetrics.getResScale() * 115,
                'action': function () {
                    if (!this.settingsManager.getSetting('general', "showUndoBoardAlert")) {
                        this.game.solitaire.Undo(true);
                        var authority = this.game.solitaire.Authority;
                        // TriPeaks specific code
                        if (authority._chainNumber) {
                            authority.CardsChained = 0;
                            authority._chainNumber = 0;
                        }
                        return;
                    }
                    this.warning = new DealWarningModal(this.ui.currentScreen, 'dialogs.boardUndoWarningHeadline', 'dialogs.boardUndoWarning',
                        function () {
                            this.game.solitaire.Undo(true);
                            var authority = this.game.solitaire.Authority;
                            // TriPeaks specific code
                            if (authority._chainNumber) {
                                authority.CardsChained = 0;
                                authority._chainNumber = 0;
                            }
                            // end of TriPeaks specific code
                            this.warning.close();
                        }.bind(this),
                        function () {
                            this.warning.close();
                        }.bind(this)
                    );
                }.bind(this)
            });
            this.controlGroup.push(this.undoBoardButton, true);

            this.solveButton = new MsftIconButton({
                'text': _s('buttons.solve'),
                'icon': 'Buttons/Solve/autosolve.png',
                'iconDown': 'Buttons/Solve/autosolve_inv.png',
                'width': Absolute.Coords.x(155), 'height': Absolute.Coords.y(82),
                'textY': Absolute.Coords.y(41),
                'letterStyle': {
                    font: (Absolute.ScreenMetrics.getResScale() * 28) + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    align: 'left'
                },
                'action': function () {
                    this.hideButtons();
                    this.game.solitaire.AutoSolve();
                }.bind(this)
            });
            this.controlGroup.push(this.solveButton, true);

            var layoutDir = (SettingsManager.getSetting('pyramid', 'layoutDirection') === '1') ? 'left' : 'right';
            this.drawButton = new MsftIconButton({
                'text': Absolute.Platform.isMobile() ? "" : _s('buttons.draw'),
                'textY': Absolute.Coords.y(39),
                'icon': 'btn_pyramid_draw_' + layoutDir + '.png',
                'iconDown': 'btn_pyramid_draw_inv_' + layoutDir + '.png',
                'iconY': Absolute.Platform.isMobile() ? Absolute.Coords.y(10) : Absolute.Coords.y(0),
                'width': Absolute.Coords.x(76),
                'height': Absolute.Coords.y(69),
                'action': function () {
                    this.game.solitaire.SupplyView.ClearHints();
                    this.game.solitaire.SupplyView.GameInputInterpreter.HighlightedCard = null;
                    this.game.solitaire.SupplyView.GameInputInterpreter.DealNextFromStock(this.game.solitaire.SupplyView);
                    this.game.solitaire.Template.UpdateStockAppearance(this.game.solitaire.SupplyView);
                }.bind(this)
            });
            this.controlGroup.push(this.drawButton, true);

            this.dealButton = new MsftIconButton({
                'text': _s('buttons.deal'),
                'fontSize': 25,
                'width': Absolute.Coords.x(76), 'height': Absolute.Coords.y(69),
                'maxWidth': Absolute.ScreenMetrics.getResScale() * 60,
                'textY': Absolute.Coords.y(38),
                'action': function () {
                    this.game.solitaire.Authority.Deal();
                }.bind(this)
            });
            this.controlGroup.push(this.dealButton, true);


            // old Y 1004
            this.challengeModeButtonY = Absolute.Coords.y(935);
            this.classicModeButtonY = Absolute.Coords.y(1004);
            this.klondikeSolveButtonY = Absolute.Coords.y(-376);

            this.newDealButton.x = this.tryAgainButton.x = Absolute.Coords.x(14);
            this.newDealButton.y = this.tryAgainButton.y = this.classicModeButtonY;
            this.tryAgainButton.visible = false;

            this.undoButton.x = Absolute.Coords.x(1785);
            this.undoButton.y = this.classicModeButtonY;

            this.undoBoardButton.x = Absolute.Coords.x(1630);
            this.undoBoardButton.y = this.classicModeButtonY;

            this.solveButton.visible = false;
            this.solveButton.x = Absolute.Coords.x(550);
            this.solveButton.y = this.klondikeSolveButtonY;

            this.drawButton.visible = false;
            this.drawButton.x = Absolute.Coords.x(-37);
            this.drawButton.y = Absolute.Coords.y(300);

            this.dealButton.visible = false;
            this.dealButton.x = Absolute.Coords.x(-37);
            this.dealButton.y = Absolute.Coords.y(380);

            this.settingsButton.visible = false;
            this.settingsButton.y = this.newDealButton.y;
            this.settingsButton.x = Absolute.Coords.x(520);

            this.hintButton.visible = false;
            this.hintButton.y = this.newDealButton.y;
            this.hintButton.x = this.newDealButton.x  + this.newDealButton.width + Absolute.Coords.x(25);

            this.addChild(this.newDealButton);
            this.addChild(this.tryAgainButton);
            this.addChild(this.undoButton);
            this.addChild(this.undoBoardButton);

            this.addChild(this.settingsButton);
            this.addChild(this.hintButton);

            this.settingsButtonWidth = this.settingsButton.width;
            this.settingsButtonHeight = this.settingsButton.height;

            this.hintButtonWidth = this.hintButton.width;
            this.hintButtonHeight = this.hintButton.height;

            this.newDealButtonWidth = this.newDealButton.width;
            this.newDealButtonHeight = this.newDealButton.height;
            this.tryAgainButtonWidth = this.tryAgainButton.width;
            this.tryAgainButtonHeight = this.tryAgainButton.height;
            this.undoButtonWidth = this.undoButton.width;
            this.undoButtonHeight = this.undoButton.height;
            this.undoBoardButtonWidth = this.undoBoardButton.width;
            this.undoBoardButtonHeight = this.undoBoardButton.height;

            this.gameViewDummy = new GameViewDummy();
            this.controlGroup.push(this.gameViewDummy);

            for (var i = 0; i < this.controlGroup.length; i++) {
                this.controlFocusManager.addControl(this.controlGroup[i], this.controlGroup[i].visible);
            }
        };

        GameScreenUI.prototype.updateUndoButtonsState = function (isEnabled) {
            if (isEnabled) {
                this.undoButton.alpha = 1;
                this.undoButton.interactive = true;
                this.undoBoardButton.alpha = 1;
                this.undoBoardButton.interactive = true;
            } else {
                this.undoButton.alpha = 0.5;
                this.undoButton.interactive = false;
                this.undoBoardButton.alpha = 0.5;
                this.undoBoardButton.interactive = false;
            }
        };

        GameScreenUI.prototype.updateControlFocus = function () {
            for (var i = 0; i < this.controlGroup.length; i++) {
                this.controlFocusManager.setControlActive(this.controlGroup[i], this.controlGroup[i].visible);
            }
        };

        GameScreenUI.prototype.hideButtons = function () {
            this.buttonsHidden = true;
            this.newDealButton.visible = false;
            this.undoButton.visible = false;
            this.undoBoardButton.visible = false;
            this.solveButton.visible = false;
            this.drawButton.visible = false;
            this.dealButton.visible = false;
            this.dealCountLabel.visible = false;
            this.settingsButton.visible = false;
            this.hintButton.visible = false;
            this.updateControlFocus();
        };

        GameScreenUI.prototype.showButtons = function () {
            this.buttonsHidden = false;
            this.newDealButton.visible = true;
            this.undoButton.visible = true;
            this.undoBoardButton.visible = this.canShowUndoBoard();
            this.solveButton.visible = true;
            this.drawButton.visible = true;
            this.dealButton.visible = true;
            this.dealCountLabel.visible = true;

            if (Absolute.Platform.isMobile()) {
                this.settingsButton.visible = true;
                this.hintButton.visible = true;                
            }
            this.updateControlFocus();
        };

        GameScreenUI.prototype.canShowUndoBoard = function () {
            return this.game.solitaire.ActiveMode.Name === 2 || this.game.solitaire.ActiveMode.Name === 3;
        };

        GameScreenUI.prototype.buildLabels = function () {
            var fontSize = Absolute.ScreenMetrics.getResScale() * 28;
            var letterStyle = {
                font: fontSize + "px Arial",
                fontFamily: 'segoe',
                fill: '#ffffff',
                align: 'left'
            };

            this.supplyBackground = new PIXI.Graphics();
                        
            if (Absolute.Platform.isMobile()) {
                fontSize = Absolute.ScreenMetrics.getResScale() * 22;
                letterStyle.font = fontSize + "px Arial";
                ScaleParams.gameScreenUI.dealLabelFontSize = Absolute.ScreenMetrics.getResScale() * 45;

                this.supplyBackground.beginFill(0x000001, 0.3);
                this.supplyBackground.drawRoundedRect(0, 0, Absolute.Coords.x(691), Absolute.Coords.y(272), Absolute.Coords.x(20));
                this.supplyBackground.endFill();
                this.supplyBackground.visible = false;
                this.supplyBackground.x = Absolute.Coords.x(-350);
                this.supplyBackground.y = Absolute.Coords.y(783);
            }
            else {
                this.supplyBackground.beginFill(0x000001, 0.3);
                this.supplyBackground.drawRoundedRect(0, 0, Absolute.Coords.x(491), Absolute.Coords.y(272), Absolute.Coords.x(20));
                this.supplyBackground.endFill();
                this.supplyBackground.visible = false;
                this.supplyBackground.x = Absolute.Coords.x(-250);
                this.supplyBackground.y = Absolute.Coords.y(783);
            }

            var gameScreenUIInfo = ScaleParams.gameScreenUI;

            this.labelContainer = new PIXI.DisplayObjectContainer();
            this.gameIcon = PIXI.Sprite.fromFrame('icon_' + this.mode + '_topUI.png');
            this.gameIcon.x = this.game.menuBar.backButton.x + Absolute.Coords.x(5);
            if (this.game.menuBar.backButton.visible) this.gameIcon.x += this.game.menuBar.backButton.width;
            this.gameIconWidth = this.gameIcon.width;
            this.gameIconHeight = this.gameIcon.height;
            this.labelsX = this.gameIcon.x + this.gameIcon.width + Absolute.Coords.x(gameScreenUIInfo.gameLabel.offsetX) / ScaleManager.scaleFactorX;

            this.difficultyText = new PIXI.Text("", letterStyle);
            _s.shrinkToFit(this.difficultyText, fontSize, '', 0);

            this.scoreLabel = new PIXI.Text(_s('titles.score'), letterStyle);
            this.scoreLabelWidth = this.scoreLabel.width;
            this.scoreLabelHeight = this.scoreLabel.height;

            this.score = new PIXI.Text(_s("0"), letterStyle);
            this.scoreWidth = this.score.width;
            this.scoreHeight = this.score.height;

            this.timeLabel = new PIXI.Text(_s('titles.time'), letterStyle);
            this.timeLabelWidth = this.timeLabel.width;
            this.timeLabelHeight = this.timeLabel.height;

            this.time = new PIXI.Text(_s("0:00"), letterStyle);
            this.timeWidth = this.time.width;
            this.timeHeight = this.time.height;

            this.boardsCompleteLabel = new PIXI.Text(_s('titles.boardsComplete'), letterStyle);
            this.boardsCompleteLabelWidth = this.boardsCompleteLabel.width;
            this.boardsCompleteLabelHeight = this.boardsCompleteLabel.height;

            this.boardsComplete = new PIXI.Text(_s("0"), letterStyle);
            this.boardsCompleteWidth = this.boardsComplete.width;
            this.boardsCompleteHeight = this.boardsComplete.height;

            this.boardsCompleteLabel.y = this.boardsComplete.y = this.timeLabel.y = this.time.y =
                this.scoreLabel.y = this.score.y = Absolute.Coords.y(gameScreenUIInfo.labelsY * ScaleManager.scaleFactorY);

            this.boardsCompleteLabel.x = this.timeLabel.x = (this.score.x + this.score.width) + Absolute.Coords.x(gameScreenUIInfo.timeLabelX);
            this.time.x = Absolute.Coords.x(gameScreenUIInfo.timeX);
            this.boardsComplete.x = this.boardsCompleteLabel.x + this.boardsCompleteLabel.width + Absolute.Coords.x(gameScreenUIInfo.boardsCompleteOffsetX);


            this.dealLabel = new PIXI.Text(this.dealsLeft.toString() + ' ' + _s('titles.dealsLeft'), {
                font: Absolute.ScreenMetrics.getResScale() * gameScreenUIInfo.dealLabelFontSize + "px Arial",
                fontFamily: 'segoe',
                fill: '#ffffff',
                align: 'center'
            });
            this.dealLabel.anchor.set(0.5, 0.5);

            this.dealLabel.visible = false;

            this.dealCountLabel = new PIXI.Text('0', {
                font: Absolute.ScreenMetrics.getResScale() * 35 + "px Arial",
                fontFamily: 'segoe',
                fill: '#ffffff',
                align: 'center'
            });
            this.dealCountLabel.anchor.set(.5, 0);
            this.dealCountLabel.visible = false;
            this.dealCountLabel.x = Absolute.Coords.x(0);
            this.dealCountLabel.y = Absolute.Coords.y(430);

            this.gameNumberLabel = new PIXI.Text(_s('titles.gameNumber'), letterStyle);
            this.gameNumberLabelWidth = this.gameNumberLabel.width;
            this.gameNumberLabelHeight = this.gameNumberLabel.height;

            this.gameNumber = new PIXI.Text('', letterStyle);
            this.gameNumber.updateText();
            this.gameNumberHeight = this.gameNumber.height;
            this.gameNumberWidth = this.gameNumber.width;
            this.gameNumberLabel.x = Absolute.Coords.x(gameScreenUIInfo.gameNumberLabel.x);
            this.gameNumber.x = Absolute.Coords.x(1750);
            this.gameNumber.y = this.gameNumberLabel.y = Absolute.Coords.y(gameScreenUIInfo.gameNumber.y);

            this.labelContainer.addChild(this.difficultyText);
            this.labelContainer.addChild(this.gameIcon);
            this.labelContainer.addChild(this.scoreLabel);
            this.labelContainer.addChild(this.score);
            this.labelContainer.addChild(this.timeLabel);
            this.labelContainer.addChild(this.time);
            this.labelContainer.addChild(this.boardsCompleteLabel);
            this.labelContainer.addChild(this.boardsComplete);
            this.labelContainer.addChild(this.gameNumberLabel);
            this.labelContainer.addChild(this.gameNumber);
        };

        GameScreenUI.prototype.updateLayout = function () {
            this.game.menuBar.resetTopBar(true);
            this.newDealButton.visible = !this.isChallenge;
            this.tryAgainButton.visible = this.isChallenge;
            this.solveButton.y = this.klondikeSolveButtonY;

            this.timeLabel.visible = this.time.visible = this.showTimer;
            this.scoreLabel.visible = this.score.visible = this.showScore;
            this.boardsCompleteLabel.visible = this.boardsComplete.visible = this.showBoardsComplete;
            this.gameNumberLabel.visible = this.gameNumber.visible = this.showGameNumber || false;

            this.gameIcon.setTexture(new PIXI.Texture.fromFrame('icon_' + this.mode + '_topUI.png'));
            this.gameIcon.x = this.game.menuBar.backButton.x + Absolute.Coords.x(20);
            if (this.game.menuBar.backButton.visible) this.gameIcon.x += this.game.menuBar.backButton.width;
            this.labelsX = this.gameIcon.x + this.gameIcon.width * this.xScale;

            if (Absolute.Platform.isMobile()) {
                var offsetX = 0;
                if (Absolute.ScreenMetrics.isPortrait()) {
                    offsetX = Absolute.Coords.x(400);
                }
                this.timeLabel.x = this.width - Absolute.Coords.x(400 + offsetX) * this.xScale;
                this.time.x = this.timeLabel.x + this.timeLabel.width + Absolute.Coords.x(25);

                if (this.showScore && !this.showTimer && this.showBoardsComplete) {
                    this.scoreLabel.x = Absolute.Coords.x(1350) * this.xScale;
                    this.score.x = this.scoreLabel.x + this.scoreLabel.width + Absolute.Coords.x(25) * this.xScale;
                    if (this.scoreLabel.x <= Absolute.Coords.x(550)) {
                        this.scoreLabel.x = Absolute.Coords.x(550);
                        this.score.x = this.scoreLabel.x + this.scoreLabel.width + Absolute.Coords.x(25) * this.xScale;
                    }
                    this.boardsCompleteLabel.x = this.score.x + this.score.width + Absolute.Coords.x(200);
                    this.boardsComplete.x = this.boardsCompleteLabel.x + this.boardsCompleteLabel.width + Absolute.Coords.x(30) * this.xScale;
                } else if (this.showScore && this.showTimer && this.showBoardsComplete) {
                    this.scoreLabel.x = Absolute.Coords.x(600) * this.xScale;
                    this.score.x = this.scoreLabel.x + this.scoreLabel.width + Absolute.Coords.x(25);
                    if (this.scoreLabel.x <= Absolute.Coords.x(550)) {
                        this.scoreLabel.x = Absolute.Coords.x(650);
                        this.score.x = this.scoreLabel.x + this.scoreLabel.width + Absolute.Coords.x(25) * this.xScale;
                    }
                    this.boardsCompleteLabel.x = this.score.x + this.score.width + Absolute.Coords.x(250) * this.resizeScale;
                    this.boardsComplete.x = this.boardsCompleteLabel.x + this.boardsCompleteLabel.width + Absolute.Coords.x(30) * this.xScale;                    
                } else if (this.showTimer || this.showBoardsComplete) {
                    this.scoreLabel.x = Absolute.Coords.x(1350) * this.xScale;
                    this.score.x = this.scoreLabel.x + this.scoreLabel.width + Absolute.Coords.x(25);
                    if (this.scoreLabel.x <= Absolute.Coords.x(550)) {
                        this.scoreLabel.x = Absolute.Coords.x(650);
                        this.score.x = this.scoreLabel.x + this.scoreLabel.width + Absolute.Coords.x(25) * this.xScale;
                    }                    
                } else {
                    this.scoreLabel.x = Absolute.Coords.x(1350) * this.xScale;
                    this.score.x = this.scoreLabel.x + this.scoreLabel.width + Absolute.Coords.x(25) * this.xScale;
                }
            }
            else {
                if (!this.showScore && this.showTimer && !this.showBoardsComplete) {
                    this.timeLabel.x = Absolute.Coords.x(820) * this.xScale;
                    this.time.x = (this.timeLabel.x + this.timeLabel.width) + Absolute.Coords.x(25) * this.xScale;
                } else if (this.showScore && !this.showTimer && this.showBoardsComplete) {
                    this.scoreLabel.x = Absolute.Coords.x(830) * this.xScale;
                    this.score.x = this.scoreLabel.x + this.scoreLabel.width + Absolute.Coords.x(25) * this.xScale;
                    if (this.scoreLabel.x <= Absolute.Coords.x(550)) {
                        this.scoreLabel.x = Absolute.Coords.x(550);
                        this.score.x = this.scoreLabel.x + this.scoreLabel.width + Absolute.Coords.x(25) * this.xScale;
                    }
                    this.boardsCompleteLabel.x = this.score.x + this.score.width + Absolute.Coords.x(200);
                    this.boardsComplete.x = this.boardsCompleteLabel.x + this.boardsCompleteLabel.width + Absolute.Coords.x(30) * this.xScale;
                } else if (this.showScore && this.showTimer && this.showBoardsComplete) {
                    this.scoreLabel.x = Absolute.Coords.x(600) * this.xScale;
                    this.score.x = this.scoreLabel.x + this.scoreLabel.width + Absolute.Coords.x(25);
                    if (this.scoreLabel.x <= Absolute.Coords.x(550)) {
                        this.scoreLabel.x = Absolute.Coords.x(550);
                        this.score.x = this.scoreLabel.x + this.scoreLabel.width + Absolute.Coords.x(25) * this.xScale;
                    }
                    this.boardsCompleteLabel.x = this.score.x + this.score.width + Absolute.Coords.x(250) * this.resizeScale;
                    this.boardsComplete.x = this.boardsCompleteLabel.x + this.boardsCompleteLabel.width + Absolute.Coords.x(30) * this.xScale;
                    this.timeLabel.x = this.boardsComplete.x + Absolute.Coords.x(this.boardsComplete.width) + Absolute.Coords.x(110) * this.xScale;
                    this.time.x = this.timeLabel.x + this.timeLabel.width + Absolute.Coords.x(25);
                } else if (this.showTimer || this.showBoardsComplete) {
                    this.scoreLabel.x = Absolute.Coords.x(830) * this.xScale;
                    this.score.x = this.scoreLabel.x + this.scoreLabel.width + Absolute.Coords.x(25);
                    if (this.scoreLabel.x <= Absolute.Coords.x(550)) {
                        this.scoreLabel.x = Absolute.Coords.x(550);
                        this.score.x = this.scoreLabel.x + this.scoreLabel.width + Absolute.Coords.x(25) * this.xScale;
                    }
                    var offsetX = Absolute.Coords.x(ScaleParams.gameScreenUI.timeLabelX);
                    if (ScaleManager.width <= 700) {
                        offsetX -= Absolute.Coords.x(150);
                    }
                    this.timeLabel.x = (this.score.x + this.score.width) + offsetX / this.xScale;
                    this.time.x = this.timeLabel.x + this.timeLabel.width + Absolute.Coords.x(25);
                } else {
                    this.scoreLabel.x = Absolute.Coords.x(871) * this.xScale;
                    this.score.x = this.scoreLabel.x + this.scoreLabel.width + Absolute.Coords.x(25) * this.xScale;
                }
            }

            if (this.showGameNumber && this.game.solitaire.Authority.CardSupply.DeckSeed) {                
                this.gameNumber.setText(this.game.solitaire.Authority.CardSupply.DeckSeed.substring(1));
                this.gameNumber.updateText();
                this.gameNumberWidth = this.gameNumber._width;
                this.gameNumberHeight = this.gameNumber._height;

                if (Absolute.Platform.isMobile())
                    this.gameNumberLabel.x = this.scoreLabel.x;
                else
                    this.gameNumberLabel.x = this.time.x + this.time.width + Absolute.Coords.x(250);
                
                this.gameNumber.x = this.gameNumberLabel.x + this.gameNumberLabel.width + Absolute.Coords.x(9);
                if (this.fullScreenEnabled) {
                    this.gameNumber.x -= Absolute.Coords.x(100) * this.xScale;
                    this.gameNumberLabel.x -= Absolute.Coords.x(100) * this.xScale;
                }
            }

            var difficultyLabel = this.isChallenge ? this.game.solitaire.CurrentChallenge.DifficultyName
                : this.game.solitaire.Authority.CardSupply.Options.DIFFICULTY;

            if (difficultyLabel) {
                difficultyLabel = Absolute.StringManager('buttons.' + difficultyLabel.toLowerCase());
            } else
                difficultyLabel = "";

            this.difficultyText.text = _s(difficultyLabel);
            this.difficultyText.updateText();

            this.difficultyText.x = this.labelsX;
            this.scoreLabel.x += Absolute.Coords.x(70);
            this.score.x += Absolute.Coords.x(70);
            this.timeLabel.x += Absolute.Coords.x(70);
            this.time.x += Absolute.Coords.x(70);
            this.gameNumber.x -= Absolute.Coords.x(70);
            this.gameNumberLabel.x -= Absolute.Coords.x(70);

            this.game.solitaire.SupplyView.addChild(this.solveButton);
            this.solveButton.destroy = function () {
                this.parent = null;
            };
            this.solveButton.x = Absolute.Coords.x(-400);
            this.solveButton.y = this.klondikeSolveButtonY;

            if (this.mode === 'spider') {
                this.settingsManager.getSetting(this.gameName.toLowerCase(), 'showDifficulty')
                this.game.solitaire.updateSetting('layoutDirection', this.settingsManager.getSetting('spider', 'layoutDirection'));
            }

            this.supplyBackground.y = Absolute.Coords.y(250);
            this.dealButton.y = Absolute.Coords.y(380);
            this.dealCountLabel.y = Absolute.Coords.y(385);
            this.drawButton.y = Absolute.Coords.y(300);

            this.dealLabel.x = Absolute.Coords.x(0);
            this.dealLabel.y = Absolute.Coords.x(500);

            if (this.mode === 'pyramid' || this.mode === 'tripeaks') {
                if (Absolute.Platform.isMobile()) {
                    this.drawButton.scale.set(1.5);
                    this.drawButton.x = Absolute.Coords.x(-55);
                    this.drawButton.y = Absolute.Coords.y(275);
                    
                    this.dealButton.scale.set(1.5);
                    this.dealButton.x = this.drawButton.x;
                    this.dealButton.y = this.drawButton.y + Absolute.Coords.y(125);

                    this.dealCountLabel.y = this.dealButton.y + Absolute.Coords.y(5);
                }

                this.supplyBackground.visible = true;
                this.dealButton.visible = true;
                this.dealCountLabel.visible = true;
                this.game.solitaire.SupplyView.addChild(this.dealButton);
                this.game.solitaire.SupplyView.addChild(this.dealCountLabel);
                this.game.solitaire.SupplyView.addChildAt(this.supplyBackground, 0);
                this.game.solitaire.SupplyView.addChild(this.dealLabel);
                this.dealLabel.destroy = function () {
                    this.parent = null;
                };
                this.drawButton.destroy = function () {
                    this.parent = null;
                };
                this.dealButton.destroy = function () {
                    this.parent = null;
                };
                this.dealCountLabel.destroy = function () {
                    this.parent = null;
                };

                var challengeYDiff = Absolute.Coords.x(51);

                if (this.mode === 'pyramid') {
                    this.drawButton.visible = true;
                    this.game.solitaire.SupplyView.addChild(this.drawButton);
                } else if (this.mode === 'tripeaks') {
                    this.drawButton.visible = false;
                }

                if (this.isChallenge) {
                    this.drawButton.y -= challengeYDiff;
                    this.supplyBackground.y -= challengeYDiff;
                    this.dealLabel.y -= challengeYDiff;
                    this.dealButton.y -= challengeYDiff;
                    this.dealCountLabel.y -= challengeYDiff;
                }

            } else {
                this.supplyBackground.visible = false;
                this.drawButton.visible = false;
                this.dealButton.visible = false;
                this.dealCountLabel.visible = false;
            }

            if (this.challengeHud && !this.alreadyShown && this.isChallenge) {
                this.labelContainer.removeChild(this.challengeHud);
                this.updateHandlers = {
                    updateChallengeTime: null,
                    updateChallengeScore: null,
                    updateChallengeMoves: null,
                    updateChallengeStacks: null,
                    updateChallengeCardsPlayed: null,
                    updateChallengeDeals: null,
                    updateChallengeBoards: null
                };
            }
            if (!this.isChallenge) {
                if ((this.gameIcon.x + this.gameIcon.width) >= this.scoreLabel.x
                    || (this.gameIcon.x + this.gameIcon.width >= this.timeLabel.x && this.showTimer)) {
                    this.gameIcon.visible = false;
                } else {
                    this.gameIcon.visible = true;
                }

                if (this.difficultyText) {
                    if ((this.difficultyText.x + this.difficultyText.width + Absolute.Coords.x(55)) >= this.scoreLabel.x
                        || (this.difficultyText.x + this.difficultyText.width + Absolute.Coords.x(55) >= this.timeLabel.x && this.showTimer)) {
                        this.difficultyText.visible = false;
                    } else {
                        this.difficultyText.visible = true;
                    }
                }
            }

            if (this.isChallenge && !this.alreadyShown) {

                this.solveButton.y = this.klondikeSolveButtonY;

                if (this.isChallenge && !this.challengeFooter) {
                    var config = {
                        gameName: this.game.solitaire.CurrentChallenge.GetModeName(),
                        gameDescription: this.game.solitaire.CurrentChallenge.GetGoalDescription(),
                        difficultyName: this.game.solitaire.CurrentChallenge.DifficultyName,
                        rewardAmount: this.isStarClub ? this.game.solitaire.CurrentChallenge.Difficulty.toString() :
                            this.game.solitaire.CurrentChallenge.Coins.toString(),
                        rewardType: this.isStarClub ? "kickoff.stars" : "kickoff.coins",
                        rewardIcon: this.isStarClub ? 'kickoff_star.png' : 'DC_kickoff_coin.png',
                        isCompleted: this.game.solitaire.CurrentChallenge.Completed
                    };
                    this.challengeFooter = new ChallengeFooter(this.ui.currentScreen, this.game, config);
                    this.challengeStartModal = new ChallengeStartModal(this.ui.currentScreen, this.game, config, this.challengeFooter, this.isRestart);
                    this.isRestart = false;
                }

                this.mapNumberToCard = {
                    "two": "Card_Twos",
                    "2": "Card_Twos",
                    "three": "Card_Threes",
                    "3": "Card_Threes",
                    "four": "Card_Fours",
                    "4": "Card_Fours",
                    "five": "Card_Fives",
                    "5": "Card_Fives",
                    "six": "Card_Sixes",
                    "6": "Card_Sixes",
                    "seven": "Card_Sevens",
                    "7": "Card_Sevens",
                    "eight": "Card_Eights",
                    "8": "Card_Eights",
                    "nine": "Card_Nines",
                    "9": "Card_Nines",
                    "ten": "Card_Tens",
                    "10": "Card_Tens",
                    "jack": "Card_Jacks",
                    "J": "Card_Jacks",
                    "queen": "Card_Queens",
                    "Q": "Card_Queens",
                    "king": "Card_Kings",
                    "K": "Card_Kings",
                    "ace": "Card_Aces",
                    "A": "Card_Aces"
                };

                var goalName = this.getGoalTypeKey(this.game.solitaire.CurrentChallenge.ChallengeType),
                    movesLimit = parseInt(this.game.solitaire.CurrentChallenge.config.Data.CHDEF_AllowedMoves) > 0,
                    dealLimit = (this.mode === 'tripeaks' || this.mode === 'pyramid') && parseInt(this.game.solitaire.CurrentChallenge.config.Data.PARAM_MAXDEALS) > 1,
                    timeLimit = parseInt(this.game.solitaire.CurrentChallenge.config.Data.CHDEF_AllowedTime) > 0,
                    hudType = 0,
                    hudItems = [];

                if (movesLimit) {
                    hudType++;
                    hudItems.push({
                        labelString: 'titles.moves',
                        handler: 'updateChallengeMoves'
                    });
                }
                if (dealLimit) {
                }
                if (timeLimit) {
                    hudType++;
                    hudItems.push({
                        labelString: 'titles.time',
                        startingValue: this.formatTime(this.game.solitaire.Authority.StartingTime),
                        handler: 'updateChallengeTime'
                    });
                }

                switch (goalName) {
                    case 'AchieveScore':
                        hudType++;
                        hudItems.push({
                            labelString: 'titles.score',
                            handler: 'updateChallengeScore'
                        });
                        break;
                    case 'SolveGame':
                    case 'PlayCard':
                        if (!movesLimit && !timeLimit) {
                            hudType++;
                            hudItems.push({
                                labelString: 'titles.time',
                                handler: 'updateChallengeTime'
                            });
                        }
                        break;
                    case 'PlayValues':
                        hudType++;
                        var card = this.game.solitaire.CurrentChallenge.config.Data.PARAM_VALUETOPLAY;
                        hudItems.push({
                            labelString: this.mapNumberToCard[card.toLowerCase()],
                            handler: 'updateChallengeCardsPlayed'
                        });
                        break;
                    case "BuildStacks":
                        hudType++;
                        hudItems.push({
                            labelString: 'titles.stacks',
                            handler: 'updateChallengeStacks'
                        });

                        break;
                    case 'ClearBoards':
                        hudType++;
                        hudItems.push({
                            labelString: 'titles.boards',
                            handler: 'updateChallengeBoards'
                        });
                        break;
                    default:
                        throw 'error: challenge/goal type not supported';
                }

                if (hudType > 3) {
                    throw 'Error: You should never have more than three hud items.';
                    hudType = 3;
                }

                this.challengeHud = new ChallengeHud(hudType);
                this.challengeDataOriginalX = {};

                _.each(hudItems, function (hudItem, index) {
                    var label = new PIXI.Text(_s(hudItem.labelString), _.extend({}, this.config.challengeLetterStyle)),
                        data = new PIXI.Text(hudItem.startingValue || '0', _.extend({}, this.config.challengeLetterStyle));
                    _s.shrinkToFit(label, this.challengeLetterFontSize, '', Absolute.Coords.x(75));
                    this.challengeHud.setLabel(label, index);
                    this.challengeHud.setData(data, index);
                    this.challengeDataOriginalX[hudItem.labelString] = data.x + data.width / 2;
                    this.updateHandlers[hudItem.handler] = data;
                }, this);
                this.challengeHud.x = Absolute.Coords.x(this.ui.width - (this.challengeHud.width));
                var backButtonRef = this.game.menuBar.backButton;
                this.challengeHud.y = backButtonRef.y + (backButtonRef.height - this.challengeHud.height) / 2;
                this.labelContainer.addChild(this.challengeHud);
            }
            var resizeFactor = this.xScale <= this.yScale ? Absolute.Coords.y(ScaleParams.gameScreenUI.labelsY) / ScaleManager.scaleFactorY :
                Absolute.Coords.y(ScaleParams.gameScreenUI.labelsY) / ScaleManager.scaleFactorY;
            this.updateControlFocus();
            if (this.difficultyText) {
                this.difficultyText.y = resizeFactor;
                this.difficultyText.x = this.labelsX + Absolute.Coords.x(20) / ScaleManager.scaleFactorX;

                if (this.isChallenge) {
                    this.difficultyText.visible =
                        (this.difficultyText.x + this.difficultyText.width + Absolute.Coords.x(10)) <= this.challengeHud.x;
                }
            }
            this.gameIcon.y = ScaleParams.gameScreenUI.icon.y * (this.resizeScale);
            if (this.isChallenge && this.challengeHud) {
                if (this.gameIcon.x + this.gameIcon.width >= this.challengeHud.x) {
                    this.gameIcon.visible = false;
                } else {
                    this.gameIcon.visible = true;
                }
            }

            this.labelsY = Absolute.Coords.y(ScaleParams.gameScreenUI.gameLabel.y) * this.resizeScale / ScaleManager.scaleFactorY;
            if (this.difficultyText) this.difficultyText.y = this.labelsY;
            this.gameNumberLabel.y = this.gameNumber.y = this.boardsCompleteLabel.y = this.boardsComplete.y = this.timeLabel.y = this.time.y =
                this.scoreLabel.y = this.score.y = Absolute.Coords.y(ScaleParams.gameScreenUI.labelsY) * this.resizeScale / ScaleManager.scaleFactorY;

            this.hintButton.visible = !this.isChallenge;
            if (Absolute.Platform.isMobile()) {
                this.settingsButton.visible = true;
                if (Absolute.ScreenMetrics.isPortrait() && ScaleManager.width < 450) {

                    this.difficultyText.visible = true;
                    this.labelsY = Absolute.Coords.y(ScaleParams.gameScreenUI.gameLabel.y - 10) * this.resizeScale / ScaleManager.scaleFactorY;

                    this.difficultyText.x = this.labelsX + Absolute.Coords.x(75);
                    this.difficultyText.y = Absolute.Coords.y(ScaleParams.gameScreenUI.gameLabel.y + 5) * this.resizeScale / ScaleManager.scaleFactorY;

                    this.scoreLabel.x = this.timeLabel.x;
                    this.scoreLabel.y = this.score.y = this.labelsY;

                    this.score.x = this.scoreLabel.x + this.scoreLabel.width + Absolute.Coords.x(25) * this.xScale;

                    this.timeLabel.y = Absolute.Coords.y(ScaleParams.gameScreenUI.gameLabel.y + 15) * this.resizeScale / ScaleManager.scaleFactorY;

                    this.time.x = this.timeLabel.x + this.timeLabel.width + Absolute.Coords.x(25);
                    this.time.y = this.timeLabel.y;

                    this.gameNumberLabel.visible = false;
                    this.gameNumber.y = this.labelsY;
                    this.gameNumber.x = this.timeLabel.x;

                    if (this.mode === 'freecell' && this.game.solitaire.Authority.CardSupply.DeckSeed) {                        
                        this.gameNumber.setText("#" + this.game.solitaire.Authority.CardSupply.DeckSeed.substring(1));
                        this.gameNumber.updateText();
                    }

                    this.boardsCompleteLabel.x = this.scoreLabel.x;
                    this.boardsCompleteLabel.y = Absolute.Coords.y(ScaleParams.gameScreenUI.gameLabel.y + 18) * this.resizeScale / ScaleManager.scaleFactorY;
                    this.boardsComplete.x = this.boardsCompleteLabel.x + this.boardsCompleteLabel.width + Absolute.Coords.x(30) * this.xScale;
                    this.boardsComplete.y = this.boardsCompleteLabel.y;
                    
                    this.newDealButton.x = Absolute.Coords.x(25);
                    this.undoButton.x = Absolute.Coords.x(1920) - this.undoButton.width - Absolute.Coords.x(25);

                    // TODO: find a less convoluted way to calculate offset
                    let offset = ((this.undoButton.x - (this.newDealButton.x + this.newDealButton.width)) - (2 * this.newDealButton.width)) / 3;
                    
                    this.settingsButton.x = this.newDealButton.x  + this.newDealButton.width + Absolute.Coords.x(offset);
                    this.hintButton.x = this.undoButton.x - this.undoBoardButton.width - Absolute.Coords.x(offset);

                    if ((this.mode === 'pyramid' || this.mode === 'tripeaks')) {
                        this.undoBoardButton.x = this.undoButton.x;
                        this.undoBoardButton.y = this.newDealButton.y - (this.newDealButton.height * 1.5);
                        this.dealLabel.y = Absolute.Coords.y(475);

                        if (this.mode === 'tripeaks') {                            
                            this.dealLabel.y = Absolute.Coords.x(465);
                            var isLeft = SettingsManager.getSetting('tripeaks', 'layoutDirection') === '1';

                            if (isLeft)
                                this.dealLabel.x = Absolute.Coords.x(200);
                            else
                                this.dealLabel.x = Absolute.Coords.x(-200);
                            
                            this.dealButton.x = this.dealLabel.x + Absolute.Coords.x(-50);
                            this.dealButton.y = this.dealLabel.y + Absolute.Coords.y(-135);                            
                        }

                        this.dealCountLabel.y = this.dealButton.y + Absolute.Coords.y(5);
                        this.dealCountLabel.x = this.dealButton.x + Absolute.Coords.x(55);

                        if (this.isChallenge) {
                            this.undoBoardButton.x = this.hintButton.x;
                            this.undoBoardButton.y = this.hintButton.y;
                            this.dealLabel.y -= challengeYDiff;
                        }
                    }
                } else { // Landscape Mode
                    if ((this.mode === 'pyramid' || this.mode === 'tripeaks')) {
                        this.dealLabel.y = Absolute.Coords.y(465);

                        if (this.mode === 'tripeaks') {
                            this.dealLabel.y = Absolute.Coords.y(475);

                            var isLeft = SettingsManager.getSetting('tripeaks', 'layoutDirection') === '1';
                            if (isLeft)
                                this.dealLabel.x = Absolute.Coords.x(200);
                            else
                                this.dealLabel.x = Absolute.Coords.x(-200);

                            this.dealButton.x = this.dealLabel.x + Absolute.Coords.x(-50);
                            this.dealButton.y = this.dealLabel.y + Absolute.Coords.y(-135);                            
                        }

                        this.dealCountLabel.y = this.dealButton.y + Absolute.Coords.y(5);
                        this.dealCountLabel.x = this.dealButton.x + Absolute.Coords.x(55);

                        this.newDealButton.x = Absolute.Coords.x(25);
                        this.undoBoardButton.x = this.undoButton.x;
                        this.undoBoardButton.y = this.undoButton.y - (this.undoButton.height * 1.25);

                        if (Absolute.ScreenMetrics.screenWidth > 1000) {
                            this.settingsButton.x = this.newDealButton.x + this.newDealButton.width + Absolute.Coords.x(100) * this.xScale;
                            this.hintButton.x = this.undoButton.x - this.undoButton.width - Absolute.Coords.x(100) * this.xScale;
                        } else {
                            this.settingsButton.x = this.newDealButton.x + this.newDealButton.width + Absolute.Coords.x(100) * this.xScale;
                            this.hintButton.x = this.undoButton.x - this.undoButton.width - Absolute.Coords.x(100) * this.xScale;
                        }

                        if (this.isChallenge) {
                            this.undoBoardButton.x = this.hintButton.x;
                            this.undoBoardButton.y = this.hintButton.y;
                            this.dealLabel.y -= challengeYDiff;
                        }

                    } else {
                        this.settingsButton.x = Absolute.Coords.x(520);
                        this.hintButton.x = Absolute.Coords.x(1030);
                    }
                }
            }
        };

        GameScreenUI.prototype.getGoalTypeKey = function (goalType) {
            var goalKey = '';

            _.each(this.game.solitaire.CurrentChallenge.GoalType, function (value, key) {
                if (goalType === value) {
                    goalKey = key;
                    return;
                }
            });

            return goalKey;
        };

        GameScreenUI.prototype.handleResize = function () {
            ScaleManager.addElement(this, { scaleChangeSource: 'Full' });
            this.game.menuBar.resetTopBar(true);
            var gameScreenUIInfo = ScaleParams.gameScreenUI;
            this.yScale = Math.max(Math.min((ScaleManager.height / 1080) + 0.2, 1), 0.7);
            this.xScale = Math.max(Math.min((ScaleManager.width / 1920) + 0.2, 1), 0.7);
            this.resizeScale = Math.min(this.yScale, this.xScale);
            this.resizeGameIcon();
            // this.resizeGameLabel(gameScreenUIInfo);
            if (this.difficultyText) this.resizeDifficultyLabel(gameScreenUIInfo);
            this.resizeGameScoreLabel(gameScreenUIInfo);
            this.resizeGameScore(gameScreenUIInfo);
            this.resizeTimeLabel(gameScreenUIInfo);
            this.resizeTime(gameScreenUIInfo);
            this.resizeBoardCompleteLabel(gameScreenUIInfo);
            this.resizeBoardCompleteNumber(gameScreenUIInfo);
            this.resizeGameNumberLabel(gameScreenUIInfo);
            this.resizeGameNumber(gameScreenUIInfo);
            this.resizeButtons(gameScreenUIInfo);
            if (this.isChallenge && this.challengeHud) {
                this.repositionChallengeHud();
            }
            this.updateLayout();
        };

        GameScreenUI.prototype.resizeButtons = function (uiInfo) {
            var screenScaleX = ScaleManager.width / Absolute.Coords.x(1920),
                screenScaleY = ScaleManager.height / Absolute.Coords.y(1080);
            this.newDealButton.width = this.newDealButtonWidth / screenScaleX;
            this.newDealButton.height = this.newDealButtonHeight / screenScaleY;
            this.tryAgainButton.width = this.tryAgainButtonWidth / screenScaleX;
            this.tryAgainButton.height = this.tryAgainButtonHeight / screenScaleY;
            this.undoButton.width = this.undoButtonWidth / screenScaleX;
            this.undoButton.height = this.undoButtonHeight / screenScaleY;
            this.undoBoardButton.width = this.undoBoardButtonWidth / screenScaleX;
            this.undoBoardButton.height = this.undoBoardButtonHeight / screenScaleY;
            this.settingsButton.width = this.settingsButtonWidth / screenScaleX;
            this.settingsButton.height = this.settingsButtonHeight / screenScaleY;
            this.hintButton.width = this.hintButtonWidth / screenScaleX;
            this.hintButton.height = this.hintButtonHeight / screenScaleY;

            if (screenScaleX < 1 && screenScaleY < 1) {
                this.newDealButton.width *= this.resizeScale;
                this.newDealButton.height *= this.resizeScale;
                this.tryAgainButton.width *= this.resizeScale;
                this.tryAgainButton.height *= this.resizeScale;
                this.undoButton.width *= this.resizeScale;
                this.undoButton.height *= this.resizeScale;
                this.undoBoardButton.width *= this.resizeScale;
                this.undoBoardButton.height *= this.resizeScale;

                this.settingsButton.width *= this.resizeScale;
                this.settingsButton.height *= this.resizeScale;
                this.hintButton.width *= this.resizeScale;
                this.hintButton.height *= this.resizeScale;
            }
            var verticalEdge = this.isChallenge ? Absolute.Coords.y(935) : Absolute.Coords.y(1010);
            this.newDealButton.y = verticalEdge - (this.newDealButton.height - (this.newDealButton.height * screenScaleY));
            this.tryAgainButton.y = verticalEdge - (this.tryAgainButton.height - (this.tryAgainButton.height * screenScaleY));
            this.undoButton.y = verticalEdge - (this.undoButton.height - (this.undoButton.height * screenScaleY));
            this.newDealButton.x = this.tryAgainButton.x = Absolute.Coords.x(15);
            this.undoButton.x = Absolute.Coords.x(1920) - this.undoButton.width - Absolute.Coords.x(15);
            this.undoBoardButton.y = verticalEdge - (this.undoBoardButton.height - (this.undoBoardButton.height * screenScaleY));
            this.undoBoardButton.x = this.undoButton.x - this.undoBoardButton.width - Absolute.Coords.x(25);

            this.settingsButton.y = this.newDealButton.y;
            this.hintButton.y = this.newDealButton.y;
            this.hintButton.x = this.newDealButton.x  + this.newDealButton.width + Absolute.Coords.x(25);
        };

        GameScreenUI.prototype.repositionChallengeHud = function () {
            this.challengeHud.handleResize();
            var backButtonRef = this.game.menuBar.backButton;
            this.challengeHud.x = Absolute.Coords.x(this.ui.width - (this.challengeHud.width));
            this.challengeHud.y = backButtonRef.y + (backButtonRef.height - this.challengeHud.height) / 2;
            var backButtonRef = this.game.menuBar.backButton;
            if (this.challengeHud.x <= backButtonRef.x + backButtonRef.width + Absolute.Coords.x(15)) {
                this.challengeHud.x = backButtonRef.x + backButtonRef.width + Absolute.Coords.x(15);
            }

            if(Absolute.Platform.isMobile())
                this.challengeHud.x -= Absolute.Coords.x(100);
        };

        GameScreenUI.prototype.resizeGameNumber = function (uiInfo) {
            var height = this.resizeScale * (this.gameNumberHeight / ScaleManager.scaleFactorY);
            var width = this.resizeScale * (this.gameNumberWidth / ScaleManager.scaleFactorX);
            this.gameNumber.width = width;
            this.gameNumber.height = height;
            this.gameNumber.y = this.labelsY;
            this.gameNumber.updateText();
        };

        GameScreenUI.prototype.resizeGameNumberLabel = function (uiInfo) {
            var height = this.resizeScale * (this.gameNumberLabelHeight / ScaleManager.scaleFactorY);
            var width = this.resizeScale * (this.gameNumberLabelWidth / ScaleManager.scaleFactorX);
            this.gameNumberLabel.width = width;
            this.gameNumberLabel.height = height;
            this.gameNumberLabel.y = this.labelsY;
            this.gameNumberLabel.updateText();
        };

        GameScreenUI.prototype.resizeBoardCompleteNumber = function (uiInfo) {
            var height = this.resizeScale * (this.boardsCompleteHeight / ScaleManager.scaleFactorY);
            var width = this.resizeScale * (this.boardsCompleteWidth / ScaleManager.scaleFactorX);
            this.boardsComplete.width = width;
            this.boardsComplete.height = height;
            this.boardsComplete.y = this.labelsY;
            this.boardsComplete.updateText();
        };

        GameScreenUI.prototype.resizeBoardCompleteLabel = function (uiInfo) {
            var height = this.resizeScale * (this.boardsCompleteLabelHeight / ScaleManager.scaleFactorY);
            var width = this.resizeScale * (this.boardsCompleteLabelWidth / ScaleManager.scaleFactorX);
            this.boardsCompleteLabel.width = width;
            this.boardsCompleteLabel.height = height;
            this.boardsCompleteLabel.y = this.labelsY;
            this.boardsCompleteLabel.updateText();
        };

        GameScreenUI.prototype.resizeTime = function (uiInfo) {
            var height = this.resizeScale * (this.timeHeight / ScaleManager.scaleFactorY);
            var width = this.resizeScale * (this.timeWidth / ScaleManager.scaleFactorX);
            this.time.width = width;
            this.time.height = height;
            this.time.y = this.labelsY;
            this.time.updateText();
        };

        GameScreenUI.prototype.resizeTimeLabel = function (uiInfo) {
            var height = this.resizeScale * (this.timeLabelHeight / ScaleManager.scaleFactorY);
            var width = this.resizeScale * (this.timeLabelWidth / ScaleManager.scaleFactorX);
            this.timeLabel.width = width;
            this.timeLabel.height = height;
            this.timeLabel.y = this.labelsY;
            this.timeLabel.updateText();
        };

        GameScreenUI.prototype.resizeGameScore = function (uiInfo) {
            var height = this.resizeScale * (this.scoreHeight / ScaleManager.scaleFactorY);
            var width = this.resizeScale * (this.scoreWidth / ScaleManager.scaleFactorX);
            this.score.width = width;
            this.score.height = height;
            this.score.y = this.labelsY;
            this.score.updateText();
        };

        GameScreenUI.prototype.resizeGameScoreLabel = function (uiInfo) {
            var height = this.resizeScale * (this.scoreLabelHeight / ScaleManager.scaleFactorY);
            var width = this.resizeScale * (this.scoreLabelWidth / ScaleManager.scaleFactorX);
            this.scoreLabel.width = width;
            this.scoreLabel.height = height;
            this.scoreLabel.y = this.labelsY;
            this.scoreLabel.updateText();
        };

        GameScreenUI.prototype.resizeDifficultyLabel = function (uiInfo) {
            this.difficultyTextWidth = this.difficultyText._width;
            this.difficultyTextHeight = this.difficultyText._height;

            var height = this.resizeScale * (this.difficultyTextHeight / ScaleManager.scaleFactorY);
            var width = this.resizeScale * (this.difficultyTextWidth / ScaleManager.scaleFactorX);

            this.difficultyText.width = width;
            this.difficultyText.height = height;
            this.difficultyText.y = this.labelsY;
            this.difficultyText.updateText();
        };

        GameScreenUI.prototype.resizeGameIcon = function () {
            var height = this.resizeScale * (this.gameIconHeight / ScaleManager.scaleFactorY);
            var width = this.resizeScale * (this.gameIconWidth / ScaleManager.scaleFactorX);
            this.gameIcon.width = width;
            this.gameIcon.height = height;
            this.gameIcon.y = ScaleManager.scaleFactorY;
        };

        GameScreenUI.prototype.onShow = function (score, time, boardsCompleted) {
            this.visible = true;            
            this.buttonsHidden = false;

            this.game.menuBar.addChild(this.labelContainer);

            this.handleScoreChange(score);
            this.handleTimeChange(time);
            this.handleBoardCompleteChange(boardsCompleted);

            this.mode = SolitaireGameMode.getModeById(this.game.solitaire.ActiveMode.Name).toLowerCase();
            this.gameName = SolitaireGameMode.getModeById(this.game.solitaire.ActiveMode.Name);

            this.isChallenge = this.game.solitaire.Authority.IsChallenge;
            this.isStarClub = this.game.solitaire.CurrentChallenge && this.game.solitaire.CurrentChallenge.IsStarClub;

            if (this.settingsManager.getSetting(this.gameName.toLowerCase(), 'showDifficulty') === undefined) {
                this.settingsManager.setSetting(this.gameName.toLowerCase(), 'showDifficulty', true);
            }
            this.showTimer = !!(this.settingsManager.getSetting(this.mode, 'timer') && !this.isChallenge);
            this.showScore = !!(this.settingsManager.getSetting(this.mode, 'score') && !this.isChallenge);
            this.showBoardsComplete = typeof this.settingsManager.getSetting(this.mode, 'boardsComplete') !== 'undefined' && !this.isChallenge;
            this.showGameNumber = !!(this.settingsManager.getSetting(this.mode, 'gameNumber') && !this.isChallenge);
            this.dealLabel.visible = false;
            this.updateLayout();
            if (this.settingsManager.getSetting(this.gameName.toLowerCase(), 'showTutorial') === undefined) {
                this.settingsManager.setSetting(this.gameName.toLowerCase(), 'showTutorial', true);
            }
            if (this.settingsManager.getSetting(this.gameName.toLowerCase(), 'showTutorial')
                && !this.isChallenge
                && !this.isSavedGame
                && !this.htp) {
                this.htp = new HowToPlayPopup({
                    'gameMode': this.mode,
                    'onClose': function () {
                        this.closeFUE();
                    }.bind(this),
                    'onToggleAlerts': function (show) {
                        this.settingsManager.setSetting(this.gameName.toLowerCase(), 'showTutorial', show);
                    }.bind(this)
                }, this.ui);
                this.labelContainer.addChild(this.htp);
            }

            if (this.settingsManager.getSetting('general', "showAlerts")) {
                if (this.game.boostType && this.game.boostType === 'wildCard') {
                    this.wildCardTip = new HowToPlayPopup({
                        'gameMode': 'wildCard',
                        'headline': null,
                        'onClose': function () {
                            this.labelContainer.removeChild(this.wildCardTip);
                            this.wildCardTip = null;
                        }.bind(this),
                        'onToggleAlerts': function (show) {
                            this.settingsManager.setSetting("general", "showAlerts", show);
                        }.bind(this)
                    }, this.ui);
                    this.labelContainer.addChild(this.wildCardTip);
                }

                if (this.game.boostType === 'wildCard' || this.game.boostType === 'extraDeal') {
                    this.showBoostFireworks(this.game.boostType);
                }
            }

            this.updateControlFocus();
            setTimeout(this.handleResize.bind(this), 100);
            setTimeout(this.game.menuBar.handleResize.bind(this.game.menuBar), 100);
            this.alreadyShown = true;
        };

        GameScreenUI.prototype.closeFUE = function () {

            if (this.htp) {
                this.labelContainer.removeChild(this.htp);
                this.htp.removeScaling();
                Absolute.SpriteUtils.destroyAllChildren(this.htp);
                this.htp = null;
            }

        };

        GameScreenUI.prototype.showBoostFireworks = function (boostType) {

            var textures = [PIXI.Texture.fromFrame('Star_orng_dot.png'),
            PIXI.Texture.fromFrame('Star_yellow_dot.png'),
            PIXI.Texture.fromFrame('Star_yel.png')],
                particleOptions = {
                    rate: { numpan: { a: 2, b: 4, center: true }, timepan: { a: 0.01, b: 0.002, center: null } },
                    mass: 1,
                    rotation: { a: [0, 1], b: [0, 3], style: 'add' },
                    velocity: [0.5, 1],
                    alpha: { a: 0.5, b: 0 },
                    scale: { a: [0.3, 0.3, 0.5], b: 0, center: null },
                    gravity: 0,
                    life: { a: 1, b: 2, center: null },
                    radius: 1,
                    crossZone: null,
                    randomDrift: null
                },
                emitter = new ParticleEmitter(this.ui, textures, particleOptions);

            this.labelContainer.addChild(emitter);

            if (boostType === 'wildCard') {
                emitter.x = this.mode === 'pyramid' ? Absolute.Coords.x(230) : Absolute.Coords.x(230);
                emitter.y = this.mode === 'pyramid' ? Absolute.Coords.y(895) : Absolute.Coords.y(885);
            } else {
                emitter.x = this.dealLabel.x + Absolute.Coords.x(8);
                emitter.y = this.dealLabel.y + Absolute.Coords.y(20);
            }

            emitter.start();
            window.setTimeout(function () {
                emitter.stop();
            }.bind(this), 600);
            window.setTimeout(function () {
                if (emitter) {
                    this.labelContainer.removeChild(emitter);
                    emitter.destroy();
                    emitter = null;
                }
            }.bind(this), 5000);

        };

        GameScreenUI.prototype.onHide = function () {
            this.visible = false;
            ScaleManager.removeElement(this);
            this.game.boostType = null;

            if (this.wildCardTip) {
                this.labelContainer.removeChild(this.wildCardTip);
                this.wildCardTip = null;
            }

            if (this.isChallenge && this.challengeFooter) {
                this.challengeFooter.destroy();
                this.challengeFooter = null;
            }

            if (this.htp) {
                this.labelContainer.removeChild(this.htp);
                Absolute.SpriteUtils.destroyAllChildren(this.htp);
                this.htp = null;
            }

            TipManager.hideTipDialog();
            this.game.menuBar.resetTopBar(false);
            this.game.menuBar.removeChild(this.labelContainer);
            this.labelContainer.removeChild(this.challengeHud)
            this.alreadyShown = false;
            this.isChallenge = false;
        };

        GameScreenUI.prototype.update = function (GameState, Authority) {

            this.gameState = GameState;

            if (!this.buttonsHidden) {
                this.solveButton.visible = (Authority && Authority.CanAutoSolve());
                this.solveButton.x = Absolute.Coords.x((SettingsManager.getSetting('klondike', 'layoutDirection') === '1') ? -438 : 189);
                this.undoButton.visible = true;
                this.undoBoardButton.visible = this.canShowUndoBoard();
                this.tryAgainButton.visible = this.isChallenge;
            }

            if ((this.mode === 'pyramid' || this.mode === 'tripeaks')) {
                this.dealsLeft = this.game.solitaire.Authority.NumDealsLeft();

                this.dealButton.visible = this.game.solitaire.Authority.AllowDealNextDeck() && this.dealsLeft > 0;

                this.dealCountLabel.visible = this.dealButton.visible;
                this.dealLabel.visible = !this.dealButton.visible;
                if (this.dealsLeft === 1) {
                    this.dealLabel.setText(this.dealsLeft.toString() + ' ' + _s('titles.dealLeft').toLowerCase());
                } else {
                    this.dealLabel.setText(this.dealsLeft.toString() + ' ' + _s('titles.dealsLeft').toLowerCase());
                }
                this.dealCountLabel.setText(this.dealsLeft.toString());
            }

            if (this.isChallenge) {
                if (this.updateHandlers.updateChallengeStacks) {
                    this.centerChallengeDataDisplay('titles.stacks', this.updateHandlers.updateChallengeStacks,
                        this.game.solitaire.Authority.GetCompletedStacks().toString());
                }
                if (this.updateHandlers.updateChallengeMoves) {
                    var totalMoves = this.game.solitaire.Authority.TotalMoves > 1
                        ? this.game.solitaire.Authority.TotalMoves - 1 : 0;
                    this.centerChallengeDataDisplay(
                        'titles.moves', this.updateHandlers.updateChallengeMoves, totalMoves.toString());
                }
                if (this.updateHandlers.updateChallengeCardsPlayed) {
                    var card = this.game.solitaire.CurrentChallenge.config.Data.PARAM_VALUETOPLAY;
                    this.centerChallengeDataDisplay(
                        this.mapNumberToCard[card.toLowerCase()],
                        this.updateHandlers.updateChallengeCardsPlayed,
                        this.game.solitaire.Authority.NumberPlayed.toString());
                }
                if (this.updateHandlers.updateChallengeDeals) {
                    var dealsUsed = this.game.solitaire.Authority.TotalDeals -
                        this.game.solitaire.Authority.NumDealsLeft() - this.game.solitaire.Authority.FreeDeals - 1,
                        adjustedDealsLeft = this.game.solitaire.Authority.CurrentDeal === 0
                            ? this.dealsLeft - 1 : this.dealsLeft;

                    if (dealsUsed < 0) {
                        dealsUsed = 0;
                    }

                    this.centerChallengeDataDisplay(
                        'titles.deals', this.updateHandlers.updateChallengeDeals, dealsUsed.toString());

                    this.dealCountLabel.setText(adjustedDealsLeft.toString());
                    this.dealLabel.setText(adjustedDealsLeft.toString() + ' ' + _s('titles.dealsLeft').toLowerCase());
                }
            }

            this.updateControlFocus();
        };

        GameScreenUI.prototype.centerChallengeDataDisplay = function (id, textObj, value) {
            var originalX = textObj.x;
            if (this.challengeDataOriginalX) {
                originalX = this.challengeDataOriginalX[id];
            }
            textObj.setText(value);
            textObj.updateText();
            textObj.x = originalX - (textObj.width / 2);
        };

        GameScreenUI.prototype.handleScoreChange = function (score) {
            this.score.setText(score ? Absolute.TextUtils.formatInt(score, Absolute.StringManager.getUserLanguage()) : '0');
            this.score.updateText();
            this.scoreWidth = this.score._width;
            this.scoreHeight = this.score._height;
            if (this.updateHandlers.updateChallengeScore) {
                this.centerChallengeDataDisplay('titles.score', this.updateHandlers.updateChallengeScore,
                    score ? Absolute.TextUtils.formatInt(score) : '0');
            }
        };

        GameScreenUI.prototype.handleTimeChange = function (seconds) {
            var formatted = this.formatTime(seconds);
            this.time.setText(formatted);
            if (this.updateHandlers.updateChallengeTime) {
                this.centerChallengeDataDisplay('titles.time', this.updateHandlers.updateChallengeTime, formatted);
            }
        };

        GameScreenUI.prototype.formatTime = function (seconds) {
            seconds = Math.floor(seconds);
            var min = Math.floor(seconds / 60),
                sec = String(seconds % 60);
            return min + ':' + (sec < 10 ? '0' + sec : sec);
        };

        GameScreenUI.prototype.handleBoardCompleteChange = function (boardsComplete) {
            this.boardsComplete.setText(boardsComplete.toString());
            this.boardsComplete.updateText();
            this.boardsCompleteWidth = this.boardsComplete._width;
            this.boardsCompleteHeight = this.boardsComplete._height;
            if (this.updateHandlers.updateChallengeBoards) {

                this.centerChallengeDataDisplay(
                    'titles.boards', this.updateHandlers.updateChallengeBoards, boardsComplete.toString());
            }
        };

        GameScreenUI.prototype.showNetworkErrorDialog = function () {
            this.ui.showWarning(_s("dialogs.networkErrorHeadline"), _s("dialogs.networkErrorContent"),
                function () {
                    this.ui.hideLoadingScreen();
                    this.game.navBack();
                }.bind(this)
            );
        };

        return GameScreenUI;

    });

